import { Injectable } from '@angular/core';
import { faro } from '@grafana/faro-web-sdk';
import { environment } from '../../../environments/environment';
import { AppConsts } from '../app-consts';

@Injectable({
    providedIn: 'root'
})
export class MonitoringService {
    constructor() {
        this.startMonitoring();
    }

    private startMonitoring(): void {
        console.log("startMonitoring")
    }

    logEvent(name: string, properties?: { [key: string]: any }): void {
        if (MonitoringService.isGrafanaEnabled()) {
            faro.api.pushEvent(name);
        }
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }): void {
        if (MonitoringService.isGrafanaEnabled()) {
            faro.api.pushMeasurement({
                type: name,
                values: {
                  duration: average,
                },
            });    
        }
    }

    logException(exception: Error, severityLevel?: number): void {
        if (MonitoringService.isGrafanaEnabled()) {
            faro.api.pushError(exception);
        }
        console.error(exception);
    }

    logTrace(message: string, properties?: { [key: string]: any }): void {
        if (MonitoringService.isGrafanaEnabled()) {
            faro.api.pushLog([message]);
        }
    }

    private static isGrafanaEnabled(): boolean {
        const isEnabled: boolean = environment[AppConsts.GrafanaConfigurationName].isEnabled;
        return isEnabled;
    }
}